import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { fetchMerchantsThunk } from "../../features/home/merchantListingSlice"; 
const MerchantCarousel = () => {
  const teamMembers = [
    { name: "", role: "" },
    { name: "", role: "" },
    { name: "", role: "" },
    { name: "", role: "" },
    { name: "", role: "" },
    { name: "", role: "" }
  ];

 const dispatch = useDispatch();
const { customizedBanners } = useSelector((state) => state.merchantListing);

// Load banners when component mounts
useEffect(() => {
  dispatch(fetchMerchantsThunk());
}, [dispatch]);

// Convert API images → usable URLs
const images = Array.isArray(customizedBanners)
  ? customizedBanners
      .slice()                   // makes a COPY (avoids read-only error)
      .sort((a, b) => a.position - b.position)
      .map(b => `${process.env.REACT_APP_IMAGE_BASE_URL}${b.bannerImage}`)
  : [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

    useEffect(() => {
  const interval = setInterval(() => {
    if (!isAnimating) {
      updateCarousel(currentIndex + 1);
    }
  }, 2000); // 3 seconds

  return () => clearInterval(interval);
}, [currentIndex, isAnimating]);

  const updateCarousel = (newIndex) => {
    if (isAnimating) return;
    setIsAnimating(true);

    const validIndex = (newIndex + teamMembers.length) % teamMembers.length;
    setCurrentIndex(validIndex);

    setTimeout(() => {
      setIsAnimating(false);
    }, 800);
  };

  const getCardPosition = (index, currentIndex, totalCards) => {
    const offset = (index - currentIndex + totalCards) % totalCards;

    if (offset === 0) return 'center';
    if (offset === 1) return 'right-1';
    if (offset === 2) return 'right-2';
    if (offset === totalCards - 1) return 'left-1';
    if (offset === totalCards - 2) return 'left-2';
    return 'hidden';
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      updateCarousel(currentIndex + 1);
    } else if (isRightSwipe) {
      updateCarousel(currentIndex - 1);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        updateCarousel(currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        updateCarousel(currentIndex + 1);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);

  const carouselStyles = {
    body: {
      minHeight: '100vh',
      background: '#0f172a',
      fontFamily: '"Poppins", sans-serif',
      overflow: 'hidden',
      position: 'relative',
      top: '-30px',
    },
    title: {
      fontSize: '3.2rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '-0.03em',
      background: 'linear-gradient(90deg, #e2e2e2, #60a5fa, #e879f9, #e2e2e2)',
      backgroundSize: '400% 100%',
      animation: 'shimmer 8s infinite linear',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent',
      textShadow: '0 0 30px rgba(96, 165, 250, 0.3)',
      marginTop: '4rem'
    },
    carouselContainer: {
  height: '500px',
  position: 'relative',
  perspective: '2200px',
  width: '100%',
  maxWidth: '1400px',
  padding: '0 20px'
},

    carouselTrack: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      transformStyle: 'preserve-3d'
    },
   card: {
  position: 'absolute',
  height: '400px',
  background: 'linear-gradient(160deg, rgba(30,41,59,0.95), rgba(15,23,42,0.95))',
  borderRadius: '24px',
  overflow: 'hidden',
  boxShadow: '0 30px 80px rgba(0,0,0,0.45)',
  transition: 'all 0.85s cubic-bezier(0.68,-0.6,0.32,1.6)',
  cursor: 'pointer',
  border: '1px solid rgba(255,255,255,0.08)',
  backdropFilter: 'blur(14px)'
},
    // cardImage: {
    //   // width: '100%',
    //   // height: '100%',
    //   objectFit: 'cover',
    //   filter: 'brightness(0.8)',
    //   transition: 'all 0.8s cubic-bezier(0.68, -0.6, 0.32, 1.6)'
    // },
    cardContent: {
  position: 'absolute',
  bottom: 0,
  left: 0,
  padding: '24px',
  width: '100%',
  color: '#fff',
  background: 'linear-gradient(to top, rgba(0,0,0,0.85), transparent)',
  transform: 'translateY(60%)',
  transition: 'transform 0.4s ease'
},

    cardName: {
      fontSize: '1.5rem',
      fontWeight: '700',
      marginBottom: '5px',
      color: 'white'
    },
    cardRole: {
      fontSize: '0.9rem',
      opacity: '0.8',
      letterSpacing: '1px',
      color: '#94a3b8'
    },
    navArrow: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'rgba(255, 255, 255, 0.1)',
      color: 'white',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      zIndex: '20',
      transition: 'all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6)',
      fontSize: '1.5rem',
      border: '2px solid rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(5px)',
      boxShadow: '0 5px 15px rgba(125, 211, 252, 0.3)'
    },
   memberInfo: {
  textAlign: 'center',
  marginTop: '2.5rem',
  color: '#fff'
},
memberName: {
  fontSize: '2.2rem',
  fontWeight: '700',
  background: 'linear-gradient(90deg,#60a5fa,#e879f9)',
  WebkitBackgroundClip: 'text',
  color: 'transparent'
},
memberRole: {
  fontSize: '1.1rem',
  opacity: '0.9',
  color: '#94a3b8'
},

    bgBlur: {
      position: 'absolute',
      width: '500px',
      height: '500px',
      borderRadius: '50%',
      filter: 'blur(100px)',
      opacity: '',
      zIndex: '0',
      mixBlendMode: 'soft-light'
    }
  };

  // Position-specific styles
  const getPositionStyles = (position) => {
    const baseStyles = { ...carouselStyles.card };
    
    switch (position) {
      case 'center':
        return {
          ...baseStyles,
          zIndex: 10,
          transform: 'scale(1.15) translateZ(0)',
          boxShadow: '0 30px 60px -10px rgba(251, 113, 133, 0.4)'
        };
      case 'left-2':
        return {
          ...baseStyles,
          zIndex: 1,
          transform: 'translateX(-400px) scale(0.8) translateZ(-200px) rotateY(15deg)',
          opacity: 0.6
        };
      case 'left-1':
        return {
          ...baseStyles,
          zIndex: 5,
          transform: 'translateX(-200px) scale(0.95) translateZ(-50px) rotateY(8deg)',
          opacity: 0.8  
        };
      case 'right-1':
        return {
          ...baseStyles,
          zIndex: 5,
          transform: 'translateX(200px) scale(0.95) translateZ(-50px) rotateY(-8deg)',
          opacity: 0.8
        };
      case 'right-2':
        return {
          ...baseStyles,
          zIndex: 1,
          transform: 'translateX(400px) scale(0.8) translateZ(-200px) rotateY(-15deg)',
          opacity: 0.6
        };
      case 'hidden':
        return {
          ...baseStyles,
          opacity: 0,
          pointerEvents: 'none'
        };
      default:
        return baseStyles;
    }
  };

  return (
    <>
      <style>{`
        @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');

        // @keyframes shimmer {
        //   0% { background-position: 0% 50%; }
        //   50% { background-position: 100% 50%; }
        //   100% { background-position: 0% 50%; }
        // }

        // @keyframes float1 {
        //   0% { transform: translate(0, 0) rotate(0deg); }
        //   50% { transform: translate(-30px, -30px) rotate(180deg); }
        //   100% { transform: translate(0, 0) rotate(360deg); }
        // }

        // @keyframes float2 {
        //   0% { transform: translate(0, 0) rotate(0deg); }
        //   50% { transform: translate(30px, -20px) rotate(-180deg); }
        //   100% { transform: translate(0, 0) rotate(-360deg); }
        // }

        // .card:hover .card-content {
        // }

        // .card.center .card-image {
        //   filter: brightness(1) !important;
        // }

        // .nav-arrow:hover {
        //   transform: translateY(-50%) scale(1.1) !important;
        //   box-shadow: 0 8px 25px rgba(96, 165, 250, 0.4), 0 0 0 4px rgba(96, 165, 250, 0.2) !important;
        // }
        /* ================= MOBILE OPTIMIZATION ================= */

/* ================= MOBILE FIX ================= */
@media (max-width: 768px) {

  /* Carousel height */
  .carousel-mobile {
    height: 320px !important;
  }

  .merchant-carousel-body {
    min-height: 2vh !important;
   
  }


  /* Base card */
  .card {
    height: 260px !important;
    border-radius: 18px !important;
    box-shadow: 0 18px 45px rgba(0,0,0,0.5) !important;
    opacity: 0;
    pointer-events: none;
    transition: all 0.5s ease;
  }

  /* 🔥 CENTER CARD — DETECT VIA SCALE */
  .card[style*="scale(1.15)"] {
    opacity: 1 !important;
    pointer-events: auto !important;
    transform: scale(1) translateZ(0) !important;
    z-index: 10;
  }

  /* Image */
  .card-image {
    width: 100%;
    height: 100%;
    // object-fit: cover;
  }

  /* Content always visible on mobile */
  .card-content {
    transform: translateY(0) !important;
    padding: 14px !important;
  }

  /* Navigation arrows */
  .nav-arrow {
    width: 36px !important;
    height: 36px !important;
    font-size: 1rem !important;
    background: rgba(255,255,255,0.2) !important;
  }

  .nav-arrow:first-of-type {
    left: 8px !important;
  }

  .nav-arrow:last-of-type {
    right: 8px !important;
  }

  /* Title */
  h1 {
    font-size: 1.6rem !important;
    margin-top: 1.5rem !important;
  }
}

/* Extra small phones */
@media (max-width: 480px) {
  .card {
    height: 230px !important;
  }

  h1 {
    font-size: 1.4rem !important;
  }
}

      `}</style>

      <div
  className="merchant-carousel-body d-flex flex-column align-items-center justify-content-center py-5"
  style={carouselStyles.body}
>
        {/* Background blur elements */}
        <div 
          style={{
            ...carouselStyles.bgBlur,
            background: 'radial-gradient(circle, #60a5fa 0%, transparent 70%)',
            animation: 'float1 20s ease-in-out infinite',
            top: '20%',
            left: '10%'
          }}
        />
        <div 
          style={{
            ...carouselStyles.bgBlur,
            background: 'radial-gradient(circle, #e879f9 0%, transparent 70%)',
            animation: 'float2 25s ease-in-out infinite',
            top: '60%',
            right: '10%'
          }}
        />

        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 text-center mb-3">
              <h1 style={carouselStyles.title}>OUR MERCHANTS</h1>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-12 d-flex justify-content-center">
              <div 
              className="carousel-mobile"
                style={carouselStyles.carouselContainer}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                {/* Left Arrow */}
                <button 
                  className="btn p-0"
                  style={{ ...carouselStyles.navArrow, left: '20px' }}
                  onClick={() => updateCarousel(currentIndex - 1)}
                  aria-label="Previous merchant"
                >
                  <i className="fas fa-chevron-left"></i>
                </button>

                {/* Carousel Track */}
                <div style={carouselStyles.carouselTrack}>
                  {teamMembers.map((member, index) => {
                    const position = getCardPosition(index, currentIndex, teamMembers.length);
                    return (
                      <div
                        key={index}
                        className="card"
                        style={getPositionStyles(position)}
                        onClick={() => updateCarousel(index)}
                      >
                        <img
  src={images[index] || "/fallback-banner.png"}
  alt="banner"
  style={{
    ...carouselStyles.cardImage,
    ...(position === "center" ? { filter: "brightness(1)" } : {}),
  }}
  className="card-image"
  loading="lazy"
  decoding="async"
/>

                        <div style={carouselStyles.cardContent} className="card-content">
                          <h3 style={carouselStyles.cardName}>{member.name}</h3>
                          <p style={carouselStyles.cardRole}>{member.role}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Right Arrow */}
                <button 
                  className="btn p-0"
                  style={{ ...carouselStyles.navArrow, right: '20px' }}
                  onClick={() => updateCarousel(currentIndex + 1)}
                  aria-label="Next merchant"
                >
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Member Info */}
          <div className="row justify-content-center">
            <div className="col-12 member-info-mobile" style={carouselStyles.memberInfo}>
              <h2 style={carouselStyles.memberName}>
                {teamMembers[currentIndex]?.name}
              </h2>
              <p style={carouselStyles.memberRole}>
                {teamMembers[currentIndex]?.role}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MerchantCarousel;